import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_bespoke-events-3/artifacts/fvgw56fc_DSC05097.jpg";

const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-end"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Bon Evento — luxury Indian wedding mandap and palace decor"
          className="w-full h-full object-cover object-center scale-105"
          loading="eager"
        />
        {/* Warm vignette to preserve natural cream + gold tones */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#080B12] via-[#080B12]/65 to-[#080B12]/15" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080B12]/55 via-transparent to-transparent" />
        <div className="absolute inset-0 bg-[#080B12]/10" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-24 pb-24 md:pb-32">
        <div className="max-w-5xl">
          <div className="overline mb-6 reveal" data-testid="hero-overline">
            Luxury Wedding Planner · Mumbai · Destination Weddings Worldwide
          </div>
          <h1
            data-testid="hero-title"
            className="font-serif text-[2.6rem] xs:text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[7.5rem] 2xl:text-[8.5rem] leading-[1.04] font-light tracking-tight text-[#F0EBE1] reveal"
          >
            Crafting
            <br />
            <span className="italic text-[#B8935C]">Bespoke</span>&nbsp;Weddings
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 sm:mt-10 max-w-xl text-base sm:text-lg leading-relaxed text-[#F0EBE1]/75 font-light reveal"
          >
            Bon Evento is a luxury wedding planner in Mumbai and a destination
            wedding planner across India and worldwide — designing bespoke
            wedding experiences, luxury decor and editorial styling for couples
            who dream beautifully.
          </p>
          <div className="mt-12 flex flex-wrap items-center gap-5 reveal">
            <a
              href="#contact"
              data-testid="hero-cta-plan"
              className="inline-flex items-center gap-3 px-8 py-4 bg-[#B8935C] text-[#080B12] text-xs uppercase tracking-[0.28em] font-medium hover:bg-[#D4AF37] transition-all duration-500"
            >
              Begin Your Wedding
            </a>
            <a
              href="#portfolio"
              data-testid="hero-cta-portfolio"
              className="inline-flex items-center gap-3 px-8 py-4 border border-[#F0EBE1]/30 text-[#F0EBE1] text-xs uppercase tracking-[0.28em] hover:border-[#B8935C] hover:text-[#B8935C] transition-all duration-500"
            >
              View Weddings
            </a>
          </div>
        </div>
      </div>

      <a
        href="#about"
        data-testid="hero-scroll-indicator"
        className="absolute bottom-8 right-6 md:right-12 lg:right-24 z-10 flex flex-col items-center gap-3 text-[#F0EBE1]/60 hover:text-[#B8935C] transition-colors"
      >
        <span className="overline text-[10px] tracking-[0.4em] rotate-90 origin-center mb-8">
          Scroll
        </span>
        <ArrowDown size={16} className="animate-bounce" />
      </a>
    </section>
  );
};

export default Hero;
